<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
  >
    <g id="bell-notification.1" opacity="0.1">
      <g id="Group_939" data-name="Group 939" transform="translate(12.667 8)">
        <path
          id="Path_8326"
          data-name="Path 8326"
          d="M9.708,43.917v.973A6.111,6.111,0,0,0,15.82,51h0a6.111,6.111,0,0,0,6.112-6.112v-.973M20.708,10.336V7.888A4.887,4.887,0,0,0,15.82,3h0a4.887,4.887,0,0,0-4.888,4.888v2.448"
          transform="translate(3.513 -3)"
          fill="none"
          :stroke="clr ? clr : '#002'"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="4.5"
        />
        <path
          id="Path_8327"
          data-name="Path 8327"
          d="M9.585,17.74h0A12.082,12.082,0,0,1,21.667,5.657H26.5A12.082,12.082,0,0,1,38.585,17.74h0V25.2a5.335,5.335,0,0,0,1.563,3.771l1.709,1.709a5.335,5.335,0,0,1,1.563,3.771h0a5.039,5.039,0,0,1-5.04,5.04H9.79a5.039,5.039,0,0,1-5.04-5.04h0a5.335,5.335,0,0,1,1.563-3.771l1.709-1.709A5.335,5.335,0,0,0,9.585,25.2V17.74Z"
          transform="translate(-4.75 1.428)"
          fill="none"
          :stroke="clr ? clr : '#002'"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="4.5"
        />
      </g>
      <path
        id="Path_8328"
        data-name="Path 8328"
        d="M0,0H64V64H0Z"
        fill="none"
      />
    </g>
  </svg>
</template>
